module.exports = __webpack_public_path__ + "static/media/view8_bg3.1a2b45dd.png";